import React, { useEffect, useState } from 'react';
import Typist from 'react-typist';
import SyncLoader from "react-spinners/SyncLoader";
import './loading.css';

const LoadingPage = () => {

    const [loading, setloading] = useState(false);

    useEffect(() => {
        setloading(true);
        setTimeout(() => {
            setloading(false);
            window.location.replace('/')
        }, 2000);
    }, [])
    return (
        <div className="divLoad">
            <div className="load-inner">
                <div className="hm-spinner">
                    <div className="hm-ring" />
                    <div className="hm-ring" />
                    <div className="hm-ring" />
                </div>
                <div className="load-text-wrap">
                    <Typist cursor={{ show: false }}>
                        <span className="spanLoad">Cargando</span>
                    </Typist>
                    <p className="load-subtitle">Por favor espere</p>
                </div>
            </div>
        </div>
    )
}

export default LoadingPage;
